import giftcard from './giftcard.json';
import gridButtons from './gridButtons.json';
import settingsLanguage from './settingsLanguage.json';

export const fo = {
  giftcard,
  gridButtons,
  settingsLanguage,
};
